<template>
  <div
    class="post_detail"
    v-if="post"
    :class="[isEnlargeView ? 'enlargen' : '', fromOutside ? 'fromOutside' : '']"
  >
    <div class="modal--backdrop" @click="closeModal"></div>
    <div class="detail_container p-relative">
      <div class="clickDv" @click="closeModal"></div>
      <div
        v-if="post.type == 'repost' && !post?.media?.length"
        class="leftAlign"
        ref="boxContainer"
      >
        <div class="post-detail-container">
          <PostInfoComponent :fromProfilePostCard="false" :post="post" />
          <div class="post--content">
            <PostProfile
              :user="postUser"
              :addPostModel="post"
              :postSubType="post.postSubType"
              :postType="post.type"
              :postPrivacy="post.postPrivacy"
              :postId="post._id"
              @avatar-click="handleAvatarClick"
            />
            <div class="body">
              <PostTextComponent :post="post" />
            </div>
          </div>
        </div>
        <div :id="`teleport-post`" class="teleport-post"></div>
      </div>
      <!-- v-if="
        (post.type === 'text' && post.postSubType === 'page') ||
        post.type === 'analysis' ||
        post.type === 'profile' ||
        post.type === 'portfolio' ||
        (!isMobileView && post.media && post.media.length)
      " -->
      <div
        v-if="post.type != 'repost'"
        class="leftAlign"
        ref="boxContainer"
        :class="{
          cardCenterAlign: post.type == 'text',
          image:
            post.type == 'media' || (post.metaData && post.metaData.length),
          pagedView: post.type === 'text' && post.postSubType === 'page',
        }"
      >
        <div class="post-detail-container">
          <PostInfoComponent :fromProfilePostCard="false" :post="post" />
          <div class="post--content">
            <PostProfile
              :user="postUser"
              :addPostModel="post"
              :postSubType="post.postSubType"
              :fromOutside="fromOutside"
              :postType="post.type"
              :postPrivacy="post.postPrivacy"
              :postId="post._id"
              @avatar-click="handleAvatarClick"
            />
            <div class="body">
              <PostTextComponent
                :post="post"
                :isDetailView="true"
                :hideQuoted="!!post.quotedImage"
              />
            </div>
          </div>
        </div>
        <div
          v-if="shouldShowDetailBox"
          style="flex-direction: column"
          class="box_detail_container"
          :class="{ quotedDetailBox: !!post.quotedImage }"
          :style="boxStyle"
        >
          <!-- Quoted text as main visual in detail -->
          <div
            v-if="post.quotedImage"
            class="detail-quoted-card text_post quotedText"
            :style="getQuotedStyle(post.quotedImage)"
          >
            <div
              class="post_message description_text expanded"
              v-html="quotedDisplayText"
            ></div>
          </div>

          <PostSectionSelectionPreviewComponent
            :post="post"
            :fromOutside="fromOutside"
            class="post-profile-section"
            v-if="post.type === 'profile' && post.postSubType == 'highlights'"
          />
          <PostMediaComponent
            :media="post.media"
            :isDetailView="true"
            v-if="post.media && post.media.length"
          />
          <PostMetaComponent
            :meta="post.metaData"
            v-if="post.metaData && post.metaData.length"
          />
          <FeedCandleChart
            :post="post"
            v-if="post.type == 'charts' || post.postSubType == 'charts'"
          />

          <WatchlistContainerComponent
            v-if="post.type == 'analysis' && post.postSubType == 'watchlist'"
            :postModel="post"
            className="postDetails boardPost"
            :isDetailView="true"
          />

          <PredictionContainerComponent
            v-if="
              post.type == 'analysis' &&
              post.postSubType == 'prediction' &&
              post.prediction &&
              post.prediction.length
            "
            :postModel="post"
            className="boardPost detailviewinfoDVanalysis"
          />

          <template
            v-if="post.type === 'analysis' && post.postSubType == 'signal'"
          >
            <div
              class="SignalCardInfoDv PostDetailSignalCardDv"
              v-if="post.signal"
            >
              <SignalCardItem
                class="CreatePostSignalInfo"
                :addPostModelDv="post.signal"
              />
            </div>
          </template>

          <PostSectionSelectionRelationPreviewComponent
            :post="post"
            class="postDetailinfoDvRelationDv"
            @onProfileClicked="closeModal"
            :fromOutside="fromOutside"
            v-if="post.type === 'profile' && post.postSubType == 'relations'"
          />

          <template
            v-if="post.type === 'portfolio' && post.postSubType == 'trade'"
          >
            <PortfolioTradePostingCardComponent
              class="TradeInfoDv"
              :trade="post.trade"
              :stock="post.stockTags[0]"
            />
          </template>

          <template v-if="post.type === 'text' && post.postSubType === 'page'">
            <PostPreviewComponent
              :show-edit-dropdown="false"
              :type="postData?.type"
              :content="postData?.data || false"
              :current-page="postData?.pageNumber"
              :total-pages="post.pagePostData?.length || 1"
              :value="postData?.pageNumber || 1"
              @update:value="setPage"
              :isDetailView="true"
            />
          </template>
        </div>
      </div>
      <div
        ref="commentList"
        class="rightAlign postDetailsWrapper"
        :class="{
          pagedView:
            (post.media && post.media.length) ||
            (post.type === 'text' && post.postSubType === 'page'),
        }"
      >
        <PostCardComponent
          @closeModal="closeModal"
          ref="cardArea"
          :post="post"
          class="PostDetailCardPreviewDv"
          :class="{ isDetailView: isOnlyTextPost }"
          :isDetailView="!isMobileView"
          :showImageViewer="true"
          :fromOutside="fromOutside"
          :postingData="postingData"
        />
        <template v-if="!fromOutside">
          <PostCommentComponent
            ref="commentSection"
            :postType="post.type"
            :sourceId="post._id"
            sourceType="post"
            v-if="isCommentView"
          />
          <PostReactionComponent
            v-else
            :style="getRightAlignStyle"
            :sourceId="post._id"
            sourceType="post"
          />
        </template>
        <template v-if="fromOutside">
          <div class="postDetailNoData">
            <IconComponent
              class="iconinfoNoDataFoundDv"
              icon="infoIconNoData.svg"
            />
            <h2>Join the Conversation</h2>
            <p>Sign in to view likes and comments.</p>
            <button class="btn btn--primary" @click="openPublicSignInDialog()">
              Sign In
            </button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import PostCommentComponent from "./PostCommentComponent.vue";
import PostReactionComponent from "./PostReactionComponent.vue";
import FeedCandleChart from "./FeedCandleChart.vue";
import PostMediaComponent from "./PostMediaComponent.vue";
import PostMetaComponent from "./PostMetaComponent.vue";
import { usePosts } from "../../composables/posts.composables";
import utilService from "@/services/util.service";
import {
  computed,
  defineComponent,
  nextTick,
  onMounted,
  ref,
  watch,
} from "vue";
import PostsModel from "../../models/posts.model";
import { useRoute, useRouter } from "vue-router";
import WatchlistContainerComponent from "../add-post/watchlist-container/WatchlistContainerComponentPost.vue";
import PostPreviewComponent from "../add-post/PostPreviewComponent.vue";
import PostSectionSelectionPreviewComponent from "./PostSectionSelectionPreviewComponent.vue";
import SignalCardItem from "../add-post/signalCreatePost/SignalCard.vue";
import PostSectionSelectionRelationPreviewComponent from "./PostSectionSelectionRelationPreviewComponent.vue";
import PortfolioTradePostingCardComponent from "./PortfolioTradePostingCardComponent.vue";
import PredictionContainerComponent from "./PredictionContainerComponent.vue";
import { TYPE } from "vue-toastification";
import { useComment } from "../../composables/comments.composable";
import { useDeviceInfo } from "@/composables/deviceinfo.composable";
import PostInfoComponent from "./PostInfoComponent.vue";
import PostProfile from "./PostProfile.vue";
import PostTextComponent from "./PostTextComponent.vue";
import User from "../../models/user.model";
import { popModal } from "jenesius-vue-modal";
import { useAuth } from "@/composables/public-auth-signin.composable";
import { useReactionStore } from "@/services/reaction.store";

export default defineComponent({
  components: {
    PredictionContainerComponent,
    PostCommentComponent,
    PostMediaComponent,
    PostSectionSelectionRelationPreviewComponent,
    SignalCardItem,
    PortfolioTradePostingCardComponent,
    PostMetaComponent,
    FeedCandleChart,
    PostReactionComponent,
    WatchlistContainerComponent,
    PostPreviewComponent,
    PostSectionSelectionPreviewComponent,
    PostInfoComponent,
    PostProfile,
    PostTextComponent,
  },
  props: ["postOnPage", "postingData", "fromOutside"],
  setup(props, context) {
    const { showPublicSignIn } = useAuth();
    const openPublicSignInDialog = async () => {
      await showPublicSignIn({
        fromHeader: true,
        fromPostDetail: true,
        postData: props.postingData,
      });
    };
    const reactionStore = useReactionStore();

    const router = useRouter();
    const boxContainer = ref<any>();
    const boxStyle = ref({ height: "0", width: "0" });
    const { getPostById, isCommentView, detailPostId, fromPopup } = usePosts();
    const isEnlargeView = ref<boolean>(false);
    const device = useDeviceInfo();
    const isMobileView = computed(() => device.isMobile || device.isTablet);
    const cardArea = ref();
    const commentSection = ref();
    const post = ref<any>();
    const postData = ref(post.value?.pagePostData[0]);
    const { comments, toggleReply } = useComment();
    const commentList = ref(null);
    const postUser = ref<User>();

    const isOnlyTextPost = computed(() => {
      var isValid = false;
      if (post.value) {
        if (post.value.type == "text") {
          isValid = true;
          if (post.value.watchList && post.value.watchList.length) {
            isValid = false;
          }
        }
      }
      return isValid;
    });

    const isTextMediaPost = computed(() => {
      return !!(
        post.value?.type == "text" &&
        post.value.media &&
        post.value.media.length
      );
    });

    const shouldShowDetailBox = computed(() => {
      const p = post.value;
      if (!p) return false;

      const hasContent = !!(
        p.quotedImage ||
        (p.media && p.media.length) ||
        (p.metaData && p.metaData.length) ||
        p.type == "charts" ||
        p.postSubType == "charts" ||
        (p.type == "analysis" && p.postSubType == "watchlist") ||
        (p.type == "analysis" &&
          p.postSubType == "prediction" &&
          p.prediction &&
          p.prediction.length) ||
        (p.type == "analysis" && p.postSubType == "signal" && p.signal) ||
        (p.type == "profile" && p.postSubType == "highlights") ||
        (p.type == "profile" && p.postSubType == "relations") ||
        (p.type == "portfolio" && p.postSubType == "trade") ||
        (p.type == "text" && p.postSubType == "page")
      );

      if (!hasContent) return false;
      // Quoted always shows once we have dimensions (or a fallback size)
      if (p.quotedImage) return true;
      return String(boxStyle.value?.width ?? "0") !== "0";
    });

    const getQuotedStyle = (quotedImage: number | string) => {
      if (!quotedImage) return {};
      try {
        return {
          background: `url(${require("@/assets/images/quoted_text/quoted_" +
            quotedImage +
            ".png")}) center center/cover no-repeat`,
        };
      } catch {
        return {};
      }
    };

    const quotedDisplayText = computed(() => {
      const p = post.value;
      if (!p) return "";
      const quoted = (p.quotedText || "").toString().trim();
      if (quoted && quoted !== ".") return p.quotedText;
      const body = (p.body || "").toString().trim();
      if (body && body !== ".") return p.body;
      return "";
    });

    const setPage = (page: any) => {
      if (Number.isNaN(page)) {
        page = 1;
      }
      postData.value = post.value?.pagePostData[page > 0 ? page - 1 : page];
    };

    const handleAvatarClick = () => {
      if (props.fromOutside) {
        popModal();
        router.push({
          name: "publicProfileShortChild",
          params: { username: postUser.value?.userName },
        });
      } else {
        popModal();
        router.push({
          name: "ProfileUser",
          params: { username: postUser.value?.userName },
        });
      }
    };

    const getRightAlignStyle = computed(() => {
      return {
        height: "100%",
        overflow: "auto",
      };
    });

    const closeModal = () => context.emit("close");

    const setBoxStyle = () => {
      if (
        post.value?.type == "paper" ||
        post.value?.type == "portfolio" ||
        post.value?.type == "watchlist" ||
        post.value?.postSubType == "watchlist"
      ) {
        var style = { height: "100%", width: "100%" };
        boxStyle.value = style;
      } else if (post.value?.quotedImage) {
        // Quoted posts need a full visual box for the background + text
        if (isEnlargeView.value) {
          boxStyle.value = { height: "100%", width: "100%" };
        } else if (boxContainer.value != null) {
          const size = Math.max(boxContainer.value.clientWidth || 360, 280);
          boxStyle.value = {
            height: `${size}px`,
            width: `${size}px`,
          };
        } else {
          boxStyle.value = { height: "360px", width: "360px" };
        }
      } else {
        var style = { height: "300px", width: "0" };
        if (isEnlargeView.value) {
          style = {
            height: "100%",
            width: "100%",
          };
        } else if (boxContainer.value != null) {
          style = {
            height: `${boxContainer.value.clientWidth}px`,
            width: `${boxContainer.value.clientWidth}px`,
          };
        }
        boxStyle.value = style;
      }
    };

    const toggleView = () => {
      isEnlargeView.value = !isEnlargeView.value;
      setTimeout(() => {
        setBoxStyle();
      }, 300);
    };

    onMounted(async () => {
     
      reactionStore.initReactionListenersForPostsReactions(
        props.fromOutside
          ? [props.postingData._id]
          : detailPostId.value
          ? [detailPostId.value]
          : [route.params.postId as string]
      );
      fromPopup.value = false;
      setBoxStyle();
      if (props.fromOutside) {
        post.value = props.postingData;
      } else {
        post.value = await getPostById(detailPostId.value);
      }
      postData.value = post.value?.pagePostData[0];
      if (post.value) {
        postUser.value = utilService.getUserFromPost(post.value);
      }
      setBoxStyle();
      nextTick(() => setBoxStyle());
      if (post.value == undefined && !props.postOnPage) {
        utilService.showToast(
          "Post not found or might have been deleted",
          TYPE.ERROR
        );
        router.push("/profile/feed");
      }
      setTimeout(() => {
        const PostDetailCardPreviewDv = document.querySelector(
          ".PostDetailCardPreviewDv"
        );
        if (PostDetailCardPreviewDv) {
          const cardAreaHeight = PostDetailCardPreviewDv.clientHeight;
          if (commentSection.value?.$el) {
            commentSection.value.$el.style.setProperty(
              "--details-meta-height",
              `${cardAreaHeight}px`
            );
          }
        }
      });
      setTimeout(() => {
        setBoxStyle();
      }, 1000);
      window.onresize = () => setBoxStyle();
    });

    watch(
      () => props,
      async (newStockData) => {
        if (props.fromOutside) {
          post.value = props.postingData;
        } else {
          post.value = await getPostById(detailPostId.value);
        }
        postData.value = post.value?.pagePostData[0];
      },
      { immediate: true, deep: true }
    );
   

    watch(
      [() => comments, toggleReply],
      async () => {
        await nextTick();
        const hasList = commentSection.value?.$el?.children?.[0];
        if (hasList) {
          hasList.scrollTop = hasList.scrollHeight;
        }
      },
      { deep: true }
    );

    const route = useRoute();

    watch(
      () => route?.path,
      () => {
        if (!route.params.postId) {
          closeModal();
        }
      }
    );
    return {
      post,
      boxStyle,
      boxContainer,
      isOnlyTextPost,
      isTextMediaPost,
      cardArea,
      commentSection,
      isMobileView,
      isEnlargeView,
      isCommentView,
      postData,
      openPublicSignInDialog,
      toggleView,
      closeModal,
      setPage,
      commentList,
      postUser,
      handleAvatarClick,
      getRightAlignStyle,
      shouldShowDetailBox,
      getQuotedStyle,
      quotedDisplayText,
    };
  },
});
</script>
<style lang="scss">
@import "../../../../../assets/scss/_postdetail.scss";

.SignalCardInfoDv {
  // background: var(--base-dark);
  // padding: 10px;
  // border-radius: 10px;
  .select_container {
    // padding-bottom: 0;
  }

  &.PostDetailSignalCardDv {
    margin: 0px auto;
    width: 80%;
    max-width: 80%;
    // .signalCardsDv {
    //   background: var(--base-light);
    // }
  }
}

.PostDetailCardPreviewDv {
  flex-shrink: 0;

  .card--post .info.post--info {
    background: var(--base-dark) !important;
  }

  .post--content {
    .foot {
      position: relative;
      z-index: 1;
    }
  }
}
.card--post {
  .post--content {
    z-index: 100;
    position: relative;
  }
}

.postDetailinfoDvRelationDv {
  max-width: 80%;
  flex: 0 0 80%;
  width: 80%;
  margin: auto;
  min-height: auto;
  height: auto;
  max-height: calc(80% - 100px);
  background: var(--base-dark) !important;
  overflow: auto;
  @include scrollbar();
}

.top_right_close_icon {
  cursor: pointer;
  color: var(--text-color) !important;
  z-index: 2;
  position: absolute !important;
  top: 20px;
  font-size: 1.1rem !important;
  right: 20px;
  text-shadow: 0 0 2px #000;
}

.TradeInfoDv {
  width: 100%;
  margin: 0px 20px;

  .new-trade-card {
    margin: 0px auto;
  }
}

// .detailviewinfoDVanalysis {
//   margin: 20px;
// //   width: 100%;
// }

.shared-post {
  .new-trade-card-body {
    padding-inline: 7px;
    gap: 10px;
  }

  .new-trade-card {
    padding-inline: calc(var(--app-modal-inner-gap) - 10px);
  }
}

.cardCenterAlign {
  justify-content: center !important;
}

.box_detail_container.quotedDetailBox {
  display: flex !important;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
}

.detail-quoted-card {
  width: 100%;
  height: 100%;
  min-height: 280px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
  padding: 24px;
  box-sizing: border-box;
  overflow: auto;

  .post_message {
    font-size: var(--font-3xl);
    font-family: Georgia, "Times New Roman", Times, serif;
    font-weight: 700;
    word-break: break-word;
    color: #fff;
    width: 100%;
    -webkit-line-clamp: unset !important;
    max-height: none !important;
    overflow: visible !important;
  }
}

.post-detail-container {
  padding-top: 20px;
  width: 95%;
  margin: 15px auto;
  background: var(--base-regular);
  border-radius: 10px;
  padding: 10px;
  // margin: 20px;
  .info.post--info {
    height: 30px;
    padding: 6px 15px;
    background-color: var(--base-dark);
    border-radius: 10px 10px 0px 0px !important;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    display: flex;
    display: flex;
    color: var(--color-new-light-gray19);
    justify-content: space-between;
    margin-top: -10px;
    margin-inline-start: -10px;
    margin-inline-end: -10px;
    .leftAlign {
      align-items: center;
      margin-inline-end: 5px;
      display: flex;
      .postInfo_icon {
        margin-top: -6px;
        fill: var(--base-text);
        color: var(--base-text);
        width: 20px;
        height: 20px;
        margin-inline-end: 8px;
        max-width: 14px;
      }
      .lightText {
        color: var(--base-text);
        font-weight: 500;
        margin-top: 0px;
        font-size: var(--font-xs);
      }
    }
  }
  .post--content {
    padding-top: 10px;
    .head {
      margin: 0 -4px 0px;
      display: flex;
      align-items: center;
      h6 {
        margin: -5px 0 0 10px;
        font-size: var(--font-sm);
        color: var(--text-color);
        line-height: 1;
        font-weight: 600;
        text-align: left;
        text-transform: capitalize;
        width: -moz-max-content;
        width: max-content;
        max-width: 100%;
        .profile_feeling {
          display: flex;
          align-items: center;
        }
        span {
          text-transform: none;
          display: block;
          font-size: var(--font-xs);
          font-weight: 500;
          color: var(--base-text);
          letter-spacing: 0px;
          line-height: 1;
          margin: 8px 0px 0px 0px;
          padding: 0px;
        }
      }
      .avatar {
        text-align: right;
        padding-inline-start: 10px;
        width: -moz-max-content;
        width: max-content;
        margin-inline-start: auto;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 2px;
        flex-direction: column;
        margin-top: -10px;
        .trademark {
          height: 20px;
          width: 20px;
          svg {
            height: 100%;
            width: 100%;
            display: block;
          }
        }
        .trademark_text {
          font-size: var(--font-xs);
          font-weight: 500;
          color: var(--base-text);
        }
        .time {
          display: block;
          text-align: right;
          font-size: var(--font-xs);
          font-weight: 500;
          margin-top: 0px;
          color: var(--base-text);
          line-height: 1;
          letter-spacing: 0px;
          margin: 5px 0px 0px 0px;
          padding: 0px;
        }
      }
      .profile_container.mini {
        margin: 0 0 -7px;
      }
      .profile_container {
        position: relative;
      }
    }
    .body {
      margin: 8px 0;
      .text_post {
        display: flex;
        align-items: flex-end;
        flex-wrap: wrap;
        max-height: calc(80dvh - 150px);
        overflow: auto;
        .post_message {
          color: var(--text-color);
          font-size: var(--font-2sm);
          font-weight: 400;
          text-align: left;
          word-break: break-word;
          letter-spacing: 0px;
          line-height: 28px;
        }
        .post_message.nonTruncate {
          max-height: unset;
        }
        a {
          color: var(--brown3);
          font-size: var(--font-xs);
          font-weight: 400;
          text-decoration: none;
          cursor: pointer;
          text-transform: uppercase;
        }

        &.quotedText {
          align-items: center;
          justify-content: center;
          text-align: center;
          min-height: 180px;
          border-radius: 12px;
          color: #fff;
          padding: 10px;

          .post_message {
            color: #fff !important;
            font-size: var(--font-3xl) !important;
            font-family: Georgia, "Times New Roman", Times, serif;
            font-weight: 700;
            text-align: center;
          }
        }
      }
    }
  }
}

@media only screen and (min-width: 1280px) and (max-width: 1891px) {
  .new-trade-card-body {
    padding-inline: 6px !important;
    gap: calc(var(--app-modal-inner-gap) - 10px) !important;
  }

  .new-trade-card {
    padding-inline: 10px;
  }

  .shared-post {
    .new-trade-card-body {
      padding-inline: 6px;
      gap: 8px;
    }

    .new-trade-card {
      padding-inline: calc(var(--app-modal-inner-gap) - 8px);
    }
  }
}
.post_detail {
  &.fromOutside {
    .detail_container {
      margin-top: 100px;
      .postDetailNoData {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 20px;
        .iconinfoNoDataFoundDv {
          width: 200px;
          height: 200px;
          margin: 0px auto;
        }
        h2 {
          font-weight: 600;
          letter-spacing: 0px;
          margin: 0px;
          padding: 0px;
          line-height: 1;
          font-size: 30px;
          color: var(--base-text-white);
        }
        p {
          line-height: 1.6;
          letter-spacing: 0px;
          flex-grow: unset;
          padding: 0px;
          color: #ffffff;
          opacity: 0.5;
          font-size: 20px;
          margin: 0px auto;
          text-align: center;
          font-weight: 400;
        }
        button {
          width: 115px;
          height: 45px;
          font-size: 16px;
          font-weight: 400;
          margin: 10px auto 0px;
        }
      }
    }
  }
}
</style>
